import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IHolidays, IInpatient, IIntervention } from 'src/app/models/IHolidays';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { LocationsService } from 'src/app/Services/AdminConfigurations/locations.service';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatPaginator } from '@angular/material/paginator';
import { ISnomed } from 'src/app/models/IProcedureCodes';
import { ICptOrdersComponent, IOrdersLoinc } from 'src/app/models/ICptOrdersComponent';
import { CptordersService } from 'src/app/Services/NewVisitNote/cptorders.service';
import { ProcedureCodesService } from 'src/app/Services/ProcedureCodes/procedure-codes.service';
import { ConfirmDialogModel } from 'src/app/group-name-dialog/group-name-dialog.component';
import { DeleteDocumentComponent } from 'src/app/PatientChart/Document/delete-document/delete-document.component';


@Component({
  selector: 'app-inpatient',
  templateUrl: './inpatient.component.html',
  styleUrls: ['./inpatient.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class InpatientComponent implements OnInit {
  headercolumnsToDisplay = [];
  columnsToDisplay = ['Diagnosis', 'Dischargedisposition', 'Facility', 'LengthOfStay', 'Action'];

  inpatient: IInpatient[] = [];
  dataSource = new MatTableDataSource(this.inpatient);
  public ispopup: boolean = false;
  public result: any;
  showpinpatient: boolean;
  public type: string;
  public procedureId: string;


  showInfo() {
    this.showpinpatient = !this.showpinpatient;
  }
  Inpatientform: FormGroup;
  submitted = false;
  public lstLocations: ILocationDetails[];
  public cptcode: string = '';
  public cptType: string = '';
  public side: string = '';
  public Procedure: string = '';
  public levels: string = '';
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private formBuilder: FormBuilder, private procedureCodesService: ProcedureCodesService, public dialog: MatDialog, private schedulerservice: SchedularServiceService, public datepipe: DatePipe, private LocationsService: LocationsService, private toastr: ToastrService, private cptservice: CptordersService,
    public dialogRef: MatDialogRef<InpatientComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IIntervention, @Inject(MAT_DIALOG_DATA) public details: DialogData,) {


  }

  OrdersLoinc: IOrdersLoinc[] = [];
  searchResultValue: string = "";
  async onOrderResultDropdownSearch(val: any) {
    this.OrdersLoinc = [];
    this.searchResultValue = val;
    if (this.searchResultValue.length >= 3) {
      await this.cptservice.getOrdersLoincMasterBySearch(this.searchResultValue).subscribe(
        data => {
          this.OrdersLoinc = data;
        }
      );
    } else {
      this.OrdersLoinc = [];

    }
  }
  onProviderselectionchange() {

  }
  MastercptOrdersDisplay: ICptOrdersComponent[];
  fnManualOrderChange(element) {
    element.loincDescription = element.loincCommanName + "~" + "(" + element.loincNumber + ")"
    this.snomedtext2 = element.loincDescription;

  }


  onClickDropdown() {

  }
  ngOnInit() {

    this.dataSource.paginator = this.paginator;
    this.Inpatientform = this.formBuilder.group({
      Diagnosis: [''],
      Dischargedisposition: [''],
      Facility: [''],
      LengthOfStay: [''],

    });
    this.GetInpatient()
  }

  getLocations() {
    this.schedulerservice.getLocations().subscribe(data => {
      this.lstLocations = data;
      this.lstLocations = this.lstLocations.filter(a => a.active == true)
    });
  }
  isUDI: number = 1;
  validoutcomes: string;
  validUDI: string;
  PassParameter: string;
  InterventioObj: IInpatient = new IInpatient();
  InPatientObj: IInpatient[];
  SaveInpatient() {
    if (this.Inpatientform.value.Diagnosis == '' && this.Inpatientform.value.Dischargedisposition == '' &&
      this.Inpatientform.value.Facility == '' && this.Inpatientform.value.LengthOfStay == '') {
      this.toastr.error("Please Enter the any Value");
      return false
    }
    var test = this.onSnomedSearchCodes;
    this.InterventioObj.encounterId = sessionStorage.getItem("encounterid").toString();
    if (this.snomedtext != undefined && this.snomedtext != '') {
      this.InterventioObj.Diagnosis = this.snomedtext
    } else {
      this.InterventioObj.Diagnosis = this.Inpatientform.get('Diagnosis').value;
    }
    if (this.snomedtext1 != undefined && this.snomedtext1 != '') {
      this.InterventioObj.Dischargedisposition = this.snomedtext1
    } else {
      this.InterventioObj.Dischargedisposition = this.Inpatientform.get('Dischargedisposition').value;
    }
    if (this.snomedtext2 != undefined && this.snomedtext2 != '') {
      this.InterventioObj.Facility = this.snomedtext2
    } else {
      this.InterventioObj.Facility = this.Inpatientform.get('Facility').value;
    }
    //  this.InterventioObj.Facility = this.snomedtext2
    this.InterventioObj.LengthOfStay = this.Inpatientform.value.LengthOfStay;
    this.LocationsService.InsertInpatient(this.InterventioObj).subscribe(
      results => {
        this.toastr.success(results);
        this.GetInpatient();
        this.onClearClick();
      }, (err: any) => {
        console.log(err);
      });
  }

  GetInpatient() {
    this.LocationsService.GetInpatient(sessionStorage.getItem("encounterid")).subscribe(
      results => {
        this.dataSource.data = results;
        results.forEach(ele => {
          if (ele.Diagnosis == null) {
            ele.Diagnosis = '';
          } else {
            if (ele.Diagnosis.includes('~')) {
              ele.Diagnosis = ele.Diagnosis.replace("~", '(');
              ele.Diagnosis = ele.Diagnosis + ")";

            }
          }

          if (ele.Dischargedisposition == null) {
            ele.Dischargedisposition = '';
          } else {
            if (ele.Dischargedisposition.includes('~')) {
              ele.Dischargedisposition = ele.Dischargedisposition.replace("~", '(');
              ele.Dischargedisposition = ele.Dischargedisposition + ")";

            }
          }
          if (ele.Facility == null) {
            ele.Facility = '';
          } else {
            if (ele.Facility.includes('~')) {
              ele.Facility = ele.Facility.replace("~", '(');
              ele.Facility = ele.Facility + ")";

            }
          }

        })
      }, (err: any) => console.log(err));

  }

  fnDelete(element: IInpatient) {
    const message = "Are you sure to delete Inpatient Details? ";
    const dialogData = new ConfirmDialogModel('Confirm Action', message);
    const dialogRef = this.dialog.open(DeleteDocumentComponent, {
      maxWidth: '400px',
      height: '120px',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      this.result = dialogResult;
      if (this.result) {
        this.LocationsService.DeleteInpatient(element.Id.toString()).subscribe(
          results => {
            this.toastr.success(results);
            this.GetInpatient()

          }, (err: any) => {
            console.log(err);
          });

      }
    })
  }

  onClearClick() {
    this.Inpatientform.controls['Diagnosis'].setValue('');
    this.Inpatientform.controls['Dischargedisposition'].setValue('');
    this.Inpatientform.controls['Facility'].setValue('');
    this.Inpatientform.controls['LengthOfStay'].setValue('');
    this.snomedtext = '';
    this.snomedtext1 = '';
    this.snomedtext2 = '';
    this.showpinpatient = false

  }

  onCancelClick() {
    this.showpinpatient = false;
  }



  searchresults: string = "";
  public MasterSnomedList: ISnomed[];
  searchMasterSnomedcodes(searchText: any) {

    if (searchText != null && searchText != undefined && searchText != '') {
      this.procedureCodesService.getSnomedBySearch(searchText).subscribe(
        results => {
          this.MasterSnomedList = results;
        }, (err: any) => console.log(err));
    }
  }
  onSnomedSearchCodes: ISnomed[] = [];

  searchReferraldropdownValue: string = "";
  async onSnomedSearch(val: any) {
    this.searchReferraldropdownValue = val;
    if (this.searchReferraldropdownValue.length > 2) {

      await this.procedureCodesService.getSnomedBySearch(this.searchReferraldropdownValue).subscribe(

        data => {
          this.onSnomedSearchCodes = data;
          this.onSnomedSearchCodes.forEach(ele => {
            ele.ConceptCodeNameCode = ele.ConceptName + "(" + ele.ConceptCode + ")";
          })
        }, (err: any) => console.log(err));
    }
    else {
      this.onSnomedSearchCodes = [];
      this.snomedtext = '';
      this.snomedtext1 = '';
      this.snomedtext2 = '';

    }
  }
  avoidspaceatfirst(e) {
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


  public snomedtext: string;
  public snomedtext1: string;
  public snomedtext2: string;
  onSelectionChanged(event) {
    this.snomedtext = event.ConceptName + "~" + event.ConceptCode;
  }

  onSelectionChanged1(event) {
    this.snomedtext1 = event.ConceptName + "~" + event.ConceptCode;
  }
}

export interface DialogData {
  headerText: string;
  proc: any;
}


